/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_Arm_RightInputs */

const en_us2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right arm`)
};

const pt_br2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braço dir.`)
};

const es_419_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brazo der.`)
};

const pt_pt2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braço dir.`)
};

const fr_fr2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bras droit`)
};

const de_de2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arm re.`)
};

const it_it2_body_measures_site_arm_right = /** @type {(inputs: Body_Measures_Site_Arm_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braccio dx`)
};

/**
* | output |
* | --- |
* | "Right arm" |
*
* @param {Body_Measures_Site_Arm_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_arm_right = /** @type {((inputs?: Body_Measures_Site_Arm_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_Arm_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_arm_right(inputs)
	if (locale === "es-419") return es_419_body_measures_site_arm_right(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_arm_right(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_arm_right(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_arm_right(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_arm_right(inputs)
	return en_us2_body_measures_site_arm_right(inputs)
});
export { body_measures_site_arm_right as "body-measures.site_arm_right" }